var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7C12.37 7 7 12.37 7 19C7 24.31 10.435 28.795 15.205 30.385C15.805 30.49 16.03 30.13 16.03 29.815C16.03 29.53 16.015 28.585 16.015 27.58C13 28.135 12.22 26.845 11.98 26.17C11.845 25.825 11.26 24.76 10.75 24.475C10.33 24.25 9.73 23.695 10.735 23.68C11.68 23.665 12.355 24.55 12.58 24.91C13.66 26.725 15.385 26.215 16.075 25.9C16.18 25.12 16.495 24.595 16.84 24.295C14.17 23.995 11.38 22.96 11.38 18.37C11.38 17.065 11.845 15.985 12.61 15.145C12.49 14.845 12.07 13.615 12.73 11.965C12.73 11.965 13.735 11.65 16.03 13.195C16.99 12.925 18.01 12.79 19.03 12.79C20.05 12.79 21.07 12.925 22.03 13.195C24.325 11.635 25.33 11.965 25.33 11.965C25.99 13.615 25.57 14.845 25.45 15.145C26.215 15.985 26.68 17.05 26.68 18.37C26.68 22.975 23.875 23.995 21.205 24.295C21.64 24.67 22.015 25.39 22.015 26.515C22.015 28.12 22 29.41 22 29.815C22 30.13 22.225 30.505 22.825 30.385C27.565 28.795 31 24.295 31 19C31 12.37 25.63 7 19 7Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGithub);
export default __webpack_public_path__ + "static/media/icon_github.8fe10a8e28f8527896ff95e3bd152ae7.svg";
export { ForwardRef as ReactComponent };